import {
  alterArrayGetProperty,
  alterArrayGetValues,
  checkModuleAssigned,
} from 'helpers';
import { CAROZO_VARIETIES } from 'helpers/Mockups';

export const filtersReducer = (state, action) => {
  switch (action.type) {
    case 'set_user_orchard':
      const getUniqueSpeciesObj = (dataArray) => {
        const speciesMap = new Map();

        dataArray.forEach((item) => {
          item.specie.forEach((specieObj) => {
            if (!speciesMap.has(specieObj.value)) {
              speciesMap.set(specieObj.value, specieObj);
            }
          });
        });

        return Array.from(speciesMap.values());
      };

      const userSpecies = getUniqueSpeciesObj(action.payload);

      // console.log(userSpecies, '-----------userSpecies');

      const shouldAddCarozo = userSpecies.some((item) =>
        CAROZO_VARIETIES.includes(item.value)
      );

      const updatedSpecies = shouldAddCarozo
        ? [...userSpecies, { label: 'Carozo', value: 'Carozo' }]
        : [...userSpecies];

      const speciesValues = alterArrayGetProperty(updatedSpecies, 'value');

      // si userSpecies contiene 'cerezo' specieDefault = cerezo sino la primera
      // TODO: especie default del mes 'Kiwi'
      const specieDefault = speciesValues.includes(state.specie_filter)
        ? state.specie_filter
        : speciesValues.includes('Cerezo')
          ? 'Cerezo'
          : speciesValues[0] || null;

      return {
        ...state,
        isLoading: false,
        withDataOrchards: true,
        userOrchard_filter: action.payload,
        userSpecies_filter: updatedSpecies,
        specie_filter: specieDefault,
      };

    case 'is_loading_orchards':
      return {
        ...state,
        isLoading: action.payload,
      };

    case 'is_loading_species':
      return {
        ...state,
        isLoading: action.payload,
      };

    case 'add_filter':
      let newObj = {};

      Object.entries(action.payload).forEach(([key, value]) => {
        return (newObj = {
          ...newObj,
          [key]: value,
        });
      });

      // console.log('----->', state, '---', newObj);

      return {
        ...state,
        ...newObj,
      };

    case 'set_species_info':
      return {
        ...state,
        isLoading: false,
        withDataSpecies: true,
        species_structure: action.payload,
      };

    case 'log_out':
      return action.payload;

    default:
      return state;
  }
};
